import React from 'react';
import { Field } from 'redux-form';
import _ from 'lodash';

import classNames from 'classnames';
import { numberWithComma } from 'src/utils/Utils';
import { formatYearMonth } from 'src/utils/Date';
import { maxLength37 } from 'src/utils/CustomValidators';
import EditableTextField from '../Util/EditableTextField';
import EditableSelectField from '../Util/EditableSelectField';
import styles from './RevisionItem.scss';

const NOTE_70_OVER = '1.70歳以上の被用者算定';
const NOTE_WORK_IN_2_OR_MORE = '2.二以上勤務';
const CHANGE_MONTHLY_REVISION_IN_JULY = '3.月額変更予定';
const MIDDLE_JOINED = '4.途中入社';
const SPECIAL_REASON_FOR_LEAVE = '5.病休・育休・休職等';
const SHORT_TIME_WORKER = '6.短時間労働者（特定適用事業所等）';
const PART_TIMER = '7.パート';
const ANNUAL_AVERAGE = '8.年間平均';
const NOTE_OTHER = '9.その他';

const ContentBottom = props => {
  const { fetchValue, showMode, selectableMonths } = props;
  const isHiddenNote = !fetchValue('isOtherNote') || (showMode === 'SHOW' && _.isEmpty(fetchValue('note')));
  const isHiddenOver70YearsOldRevisionDate1 =
    !fetchValue('isOver70YearsOld') || (showMode === 'SHOW' && _.isEmpty(fetchValue('over70YearsOldRevisionDate1')));
  const isHiddenOver70YearsOldRevisionDate2 =
    !fetchValue('over70YearsOldRevisionDate1') ||
    (showMode === 'SHOW' && _.isEmpty(fetchValue('over70YearsOldRevisionDate2')));

  return (
    <div className={styles.contentBottom}>
      <div className={styles.boxHeader}>決定後の健保</div>
      <div>
        {fetchValue('afterHealthInsuranceGrade')}
        <span className="unit">等級</span>
      </div>
      <div className={styles.amount}>
        {numberWithComma(fetchValue('afterMonthlyCompensationHealthInsuranceAmount'))}
        <span className="unit">円</span>
      </div>
      <div className={styles.boxHeader}>決定後の厚年</div>
      <div>
        {fetchValue('afterPensionInsuranceGrade')}
        <span className="unit">等級</span>
      </div>
      <div className={styles.amount}>
        {numberWithComma(fetchValue('afterMonthlyRemunerationPensionInsuranceAmount'))}
        <span className="unit">円</span>
      </div>
      <div className={styles.boxHeader}>備考</div>
      <div>
        <div className={styles.remarks}>
          <Field
            name="isOver70YearsOld"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isOver70YearsOld')
            })}
            width="initial"
            label={NOTE_70_OVER}
            showValue={NOTE_70_OVER}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isWorkInTwoOrMore"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isWorkInTwoOrMore')
            })}
            width="initial"
            label={NOTE_WORK_IN_2_OR_MORE}
            showValue={NOTE_WORK_IN_2_OR_MORE}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isChangeMonthlyRevisionInJuly"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isChangeMonthlyRevisionInJuly')
            })}
            width="initial"
            label={CHANGE_MONTHLY_REVISION_IN_JULY}
            showValue={CHANGE_MONTHLY_REVISION_IN_JULY}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isMiddleJoined"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isMiddleJoined')
            })}
            width="initial"
            label={MIDDLE_JOINED}
            showValue={MIDDLE_JOINED}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
        </div>
        {!isHiddenOver70YearsOldRevisionDate1 && (
          <div className={classNames(styles.remarks, styles.oldRevisionDate)}>
            <Field
              name="over70YearsOldRevisionDate1"
              showValue={formatYearMonth(fetchValue('over70YearsOldRevisionDate1'))}
              showMode={showMode}
              textAlign="center"
              options={selectableMonths([5, 6])}
              Width={100}
              component={EditableSelectField}
              addBlankOption
            />
            {!isHiddenOver70YearsOldRevisionDate2 && (
              <Field
                name="over70YearsOldRevisionDate2"
                showValue={formatYearMonth(fetchValue('over70YearsOldRevisionDate2'))}
                showMode={showMode}
                textAlign="center"
                options={selectableMonths([5, 6])}
                Width={100}
                component={EditableSelectField}
                addBlankOption
              />
            )}
          </div>
        )}
        <div className={styles.remarks}>
          <Field
            name="isSpecialReasonForLeave"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isSpecialReasonForLeave')
            })}
            width="initial"
            label={SPECIAL_REASON_FOR_LEAVE}
            showValue={SPECIAL_REASON_FOR_LEAVE}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isShortTimeWorker"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isShortTimeWorker')
            })}
            width="initial"
            label={SHORT_TIME_WORKER}
            showValue={SHORT_TIME_WORKER}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isPartTimer"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isPartTimer')
            })}
            width="initial"
            label={PART_TIMER}
            showValue={PART_TIMER}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
          <Field
            name="isAnnualAverage"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isAnnualAverage')
            })}
            width="initial"
            label={ANNUAL_AVERAGE}
            showValue={ANNUAL_AVERAGE}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
        </div>
        <div className={styles.remarks}>
          <Field
            name="isOtherNote"
            className={classNames(styles.noteCheck, {
              [styles.disabled]: showMode === 'SHOW' && !fetchValue('isOtherNote')
            })}
            width="initial"
            label={NOTE_OTHER}
            showValue={`${NOTE_OTHER}${_.isEmpty(fetchValue('note')) ? '' : '：'}`}
            showMode={showMode}
            textAlign="left"
            type="checkbox"
            component={EditableTextField}
          />
        </div>
        {!isHiddenNote && (
          <div className={styles.remarks}>
            <Field
              name="note"
              className={classNames(styles.noteText, {
                [styles.noteTextPreview]: showMode === 'SHOW'
              })}
              inputHeight={32}
              showValue={fetchValue('note')}
              showMode={showMode}
              textAlign="left"
              component={EditableTextField}
              validate={[maxLength37]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentBottom;
